import { NEW_API_ROUTE_ADMIN_DRILL_DOWN_DEPARTMENT_COST_OBJECTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type {
  CostObjectReportOriginal,
  DrillDownParamsOriginal,
  EntityOriginal,
  ListResponse,
} from './types'

type DDCostObjectByDepartmentResponse = ListResponse<CostObjectReportOriginal> & {
  department: EntityOriginal
}

const IS_NEW_BACKEND_API = true

export const getDrillDownCostObjectsByDepartments = async (params: DrillDownParamsOriginal) => {
  const query = new URLSearchParams({ ...params })

  const categoryResult = await get<DDCostObjectByDepartmentResponse>(
    `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_DEPARTMENT_COST_OBJECTS}?${query.toString()}`,
    IS_NEW_BACKEND_API
  )

  return {
    ...categoryResult,
    rows: categoryResult.rows.map(category => ({
      ...category,
      amount: Number(category.amount),
      salaryDeductionAmount: Number(category.salaryDeductionAmount),
    })),
  }
}
